import { css } from '@emotion/react'
import { colors, mq } from 'plume-ui'
import { IcomoonIcon } from '../../../atoms/IcomoonIcon'
import React from 'react'

type Props = {
  title: string
  selected: boolean
  opening: boolean
  className?: string
  children: React.ReactNode
  toggleOpen: () => void
}

export const SearchCondition: React.FC<Props> = (props) => {
  return (
    <div
      css={css`
        background-color: ${colors.cyan50};
        border-radius: 50px;
        color: ${colors.white00};
        display: inline-block;
        font-size: 13px;
        position: relative;
        margin-right: 5px;
        ${mq.untilMedium} {
          margin-bottom: 5px;
        }
      `}
      onClick={(e) => {
        e.stopPropagation()
      }}
      className={props.className}
    >
      <li
        css={css`
          padding: 5px 10px 5px 15px;
          cursor: pointer;
        `}
        onClick={() => {
          props.toggleOpen()
        }}
      >
        {props.selected ? (
          <span
            css={css`
              padding-right: 2px;
            `}
          >
            <IcomoonIcon name="check1" />
          </span>
        ) : null}
        <span
          css={css`
            padding-right: 5px;
          `}
        >
          {props.title}
        </span>
        <IcomoonIcon
          name="arrow8-down"
          css={css`
            font-size: 10px;
          `}
        />
      </li>
      <ul
        css={css`
          opacity: ${props.opening ? 1 : 0};
          visibility: ${props.opening ? 'visible' : 'hidden'};
          background: #fff;
          border: 1px solid #d9d9d9;
          box-shadow: 1px 1px 1px #d9d9d9;
          padding: 5px 0;
          position: absolute;
          list-style: none;
          min-width: 220px;
          white-space: nowrap;
          transition: 0.2s;
          z-index: 1;
          left: -25px;
          margin-top: 7.5px;
          ${balloonStyle}
        `}
      >
        {props.children}
      </ul>
    </div>
  )
}

const balloonStyle = css`
  :before,
  :after {
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fff;
    top: -9px;
    content: ' ';
    height: 0;
    position: absolute;
    width: 0;
    left: 13%;
  }
  :before {
    top: -10px;
    border-bottom-color: #d9d9d9;
  }
`
